import { RemoteAdminData } from 'app/infrastructure/remote-data';
import { ApiResponse, Value } from 'app/types-shared';
import { endpoints } from './endpoints';
import { FavouriteItemWire } from './types';

export const api = {

  loadLanguageOptions: async (): Promise<Value[]> => {
    const response = await new RemoteAdminData(endpoints.languageOptions)
      .resource<ApiResponse<Value[]>>()
      .all();

    return response.data;
  },

  loadFavourite: async (id: number): Promise<FavouriteItemWire> => {
    const response = await new RemoteAdminData(endpoints.favouriteItem)
      .resource<ApiResponse<FavouriteItemWire>>()
      .withId(id)
      .single();

    return response.data;
  },

  deleteFavourite: (id: number): Promise<void> => {
    return new RemoteAdminData(endpoints.favouriteItem)
      .resource<void>()
      .withId(id)
      .httpDelete({});
  },

  saveFavourite: async (id: number, favourite: FavouriteItemWire, addOwnersToDescendants?: boolean): Promise<number> => {
    await new RemoteAdminData(endpoints.favouriteItem)
      .resource<void>()
      .withId(id)
      .filter({ id, addOwnersToDescendants })
      .save(favourite);

    return id;
  },

  deleteSchedule: (id: number): Promise<void> => {
    return new RemoteAdminData(endpoints.deleteSchedule(id))
      .resource<void>()
      .httpDelete({});
  }
};
